

/* BEGIN tactical-sling-edc-buyer-highlights-20260731 */
;(function () {
  var expected = ["Extra-thick, wide shoulder-strap padding, an adjustable strap buckle, and breathable mesh back padding help reduce shoulder pressure and improve carrying comfort.","Water-resistant 900D polyester, a military-standard SBS zipper, and secure KAM buckles provide durable everyday construction and quick access to gear.","MOLLE webbing, a hook-and-loop patch area, a tool slot, and a side storage pocket expand attachment, personalization, and organization options."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-tactical-sling-pack-edc-travel-compact-messenger-molle-bag') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END tactical-sling-edc-buyer-highlights-20260731 */
